import { useAppDispatch, useAppSelector } from 'app/store';
import { fetchStorageEffect } from 'app/store/Storage/effects';
import { getStorage, getStorageLink } from 'app/store/Storage/selectors';
import { useEffect, useState } from 'react';
import { StorageWidgetProps } from './types';
import { prepareStorageData } from './utils';

export const useFetchStorage = () => {
  const dispatch = useAppDispatch();
  const storageData = useAppSelector(getStorage);
  const storageLink = useAppSelector(getStorageLink);
  const [storage, setStorage] = useState<StorageWidgetProps>();

  useEffect(() => {
    if (!storageData && storageLink) {
      dispatch(fetchStorageEffect());
    } else {
      setStorage(prepareStorageData(storageData));
    }
  }, [dispatch, storageData, storageLink]);

  return storage;
};
